import { render } from "./UserCommunication.vue?vue&type=template&id=6bb885f0&scoped=true&ts=true"
import script from "./UserCommunication.vue?vue&type=script&lang=ts"
export * from "./UserCommunication.vue?vue&type=script&lang=ts"

import "./UserCommunication.vue?vue&type=style&index=0&id=6bb885f0&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb885f0"]])

export default __exports__